export default {
  nav: {
    categories: 'Kategoriat',
    topSites: 'Huippusivustot',
    compare: 'Vertaa',
    submitSite: 'Lähetä sivusto',
    about: 'Tietoa',
    logIn: 'Kirjaudu',
  },
  common: {
    back: 'Takaisin',
    search: 'Haku',
    loading: 'Ladataan…',
    viewSimilarSites: 'Katso samanlaisia sivustoja',
  },
  hero: {
    badge: 'Sivustojen löytökone',
    titleA: 'Löydä sivustoja, jotka muistuttavat',
    titleB: 'suosikkejasi.',
    titlePrefix: 'Löydä sivustoja, jotka muistuttavat',
    titleAccent: 'suosikkejasi.',
    subtitle: 'Löydä kilpailijoita, vaihtoehtoja ja piilotettuja helmiä tarkkojen samankaltaisuuspisteiden avulla.',
    placeholder: 'Syötä domain (esim. stripe.com)',
    inputPlaceholder: 'Syötä domain (esim. stripe.com)',
    step1Label: 'Syötä domain',
    step1Desc: 'Kirjoita verkkosivun osoite aloittaaksesi',
    step2Label: 'Saat osumia',
    step2Desc: 'Moottorimme löytää samankaltaiset sivustot heti',
    step3Label: 'Vertaa ja päätä',
    step3Desc: 'Analysoi ja vertaile vaihtoehtoja',
    steps: {
      step1Label: 'Syötä domain',
      step1Desc: 'Kirjoita verkkosivun osoite aloittaaksesi',
      step2Label: 'Saat osumia',
      step2Desc: 'Moottorimme löytää samankaltaiset sivustot heti',
      step3Label: 'Vertaa ja päätä',
      step3Desc: 'Analysoi ja vertaile vaihtoehtoja',
    },
  },
  footer: {
    newsletterTitle: 'Pysy ajan tasalla',
    newsletterDesc: 'Saat viikoittaiset raportit trendisivustoista ja uusista vaihtoehdoista.',
    emailPlaceholder: 'sinun@sähköposti.fi',
    subscribe: 'Tilaa',
    brandDesc: 'Löydä verkon piilotetut yhteydet. Etsi suosikeillesi samankaltaisia sivustoja tarkalla pisteytyksellä.',
    explore: 'Tutki',
    popular: 'Suosittua',
    company: 'Yritys',
    compareSites: 'Vertaa sivustoja',
    sitesLike: 'Sivustoja kuten',
    contact: 'Yhteystiedot',
    faq: 'FAQ',
    removeYourSite: 'Poista sivustosi',
    privacyPolicy: 'Tietosuojakäytäntö',
    termsOfService: 'Käyttöehdot',
    rights: 'Kaikki oikeudet pidätetään.',
  },
  notFound: {
    title: 'Hups! Sivua ei löytynyt',
    returnHome: 'Takaisin etusivulle',
  },
  submitPage: {
    ctaTitle: 'Tunnetko loistavan sivuston?',
    ctaDesc: 'Auta meitä kasvattamaan tietokantaa lähettämällä suosikkisivustoja. Vie vain muutama sekunti.',
    ctaButton: 'Lähetä sivusto',
    pageTitle: 'Lähetä sivusto',
    pageSubtitle: 'Lähetä sivusto indeksoitavaksi.',
    successTitle: 'Sivusto lähetetty!',
    successReviewPrefix: 'Tarkistamme',
    successReviewSuffix: 'ja lisäämme sen pian indeksiimme.',
    backHome: 'Takaisin etusivulle',
    domainLabel: 'Domain *',
    domainPlaceholder: 'esim. example.com',
    descriptionLabel: 'Kuvaus',
    descriptionPlaceholder: 'Lyhyt kuvaus sivustosta',
    categoryLabel: 'Kategoria',
    categorySelect: 'Valitse kategoria',
    alternativeTo: 'Vaihtoehto kohteelle (valinnainen)',
    alternativeNone: 'Ei — ei vaihtoehto',
    emailLabel: 'Sähköpostisi',
    emailPlaceholder: 'sinu@esimerkki.fi',
    submitButton: 'Lähetä sivusto',
    submitFailed: 'Lähetys epäonnistui',
    seoTitle: 'Lähetä sivusto | CiteMatch',
    seoDesc: 'Lähetä sivusto indeksoitavaksi CiteMatchiin.',
  },
};

